import React, { useEffect, useState } from "react";
import TableCard from "../../components/TableCard";
import { HandshakeSharp } from "@mui/icons-material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import CheckIcon from "@mui/icons-material/Check";
import { keyframes } from "@emotion/react";
import {
  atualizarCondicaoComercial,
  buscarCondicoesComerciais,
  buscarCondicoesComerciaisPorTexto,
  cadastrarCondicaoComercial,
  excluirCondicaoComercial,
} from "../../services/api-financeiro.service";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  TextField,
} from "@mui/material";
import styles from "./styles.module.css";
import GenericDatePicker from "../../components/GenericDatePicker";
import { buscarComboPorCodigo } from "../../services/auth.service";
import BlueButton from "../../components/BlueButton";
import WhiteButton from "../../components/WhiteButton";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import Loading from "../../components/Loading";

const CondicaoComercial = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPage, setRowsPage] = useState(5);
  const [openModalInsert, setOpenModalInsert] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [listaServicos, setListaServicos] = useState([
    { value: "", label: "" },
  ]);
  const [idCondicaoComercial, setIdCondicaoComercial] = useState(null);
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [validoDe, setValidoDe] = useState({ content: null, error: false });
  const [percentual, setPercentual] = useState({ content: "0", error: false });
  const [imposto, setImposto] = useState({ content: "0", error: false });
  const [servico, setServico] = useState({ content: null, error: false });
  const [prazo, setPrazo] = useState({ content: "0", error: false });

  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [msg, setMsg] = useState(null);

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };
  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const columns = [
    "Serviço",
    "Válido De",
    "Válido Até (Calculado)",
    "Porcentual",
    "Imposto",
    "Prazo",
  ];

  const handleAtualizaDados = async () => {
    try {
      setLoading(true);
      const response = await buscarCondicoesComerciais(idGrupoEconomico);
      const responseOrganizada = handleOrganizaData(
        response.condicoesComerciais
      );
      setData(responseOrganizada);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await buscarCondicoesComerciais(idGrupoEconomico);
        const responseOrganizada = handleOrganizaData(
          response.condicoesComerciais
        );
        setData(responseOrganizada);
      } catch (error) {
        setData([]);
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    idGrupoEconomico ? fetchData() : setData([]);
  }, [idGrupoEconomico]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const listaServicosApi = await handleRenderListAutoComplete("SERVICO");
        const novaListaServicos = listaServicosApi.map((item) => ({
          value: item.id,
          label: item.detalhes,
        }));

        setListaServicos(novaListaServicos);
      } catch (error) {
        console.log(error);
      }
    };
    if (openModalInsert && !isEdit) fetch();
  }, [openModalInsert]);

  const handleRenderListAutoComplete = async (codCombo) => {
    const response = await buscarComboPorCodigo(codCombo);
    const combosFormat = response.detalhes.itensCombo
      .filter((item) => item)
      .map((item) => {
        const split = item.split("/|/");
        return {
          id: split[0],
          detalhes: split[1],
        };
      });

    return combosFormat;
  };

  const handleOpenModalInsert = async () => {
    setOpenModalInsert(true);
  };

  const handleOpenModalDelete = async () => {
    setOpenModalDelete(true);
  };

  const handleCloseModalInsert = () => {
    setOpenModalInsert(false);
    setListaServicos([]);
    setValidoDe({ content: null, error: false });
    setPercentual({ content: "0", error: false });
    setImposto({ content: "0", error: false });
    setServico({ content: null, error: false });
    setPrazo({ content: "0", error: false });
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const handleOrganizaData = (dados) => {
    return dados.map((item) => {
      return {
        servico: item.ServicosORM.descricao,
        validoDe: new Date(
          new Date(item.validoDe).getTime() + 3 * 60 * 60 * 1000
        ).toLocaleDateString("pt-BR"),
        validoAte: item.validoAte
          ? new Date(
              new Date(item.validoAte).getTime() + 3 * 60 * 60 * 1000
            ).toLocaleDateString("pt-BR")
          : "",
        porcentual: item.percentual.replace(".", ",") + "%",
        imposto: item.imposto.replace(".", ",") + "%",
        prazo: item.prazo,
        botoes: [
          {
            icon: <EditIcon />,
            title: "EDITAR",
            onClick: async () => {
              try {
                setIsEdit(true);
                const listaServicosApi = await handleRenderListAutoComplete(
                  "SERVICO"
                );
                const novaListaServicos = listaServicosApi.map((item) => ({
                  value: item.id,
                  label: item.detalhes,
                }));

                setListaServicos(novaListaServicos);
                setIdCondicaoComercial(item.idCondicaoComercial);
                setValidoDe(item.validoDe);
                setPercentual({ content: item.percentual, error: false });
                setImposto({ content: item.imposto, error: false });
                setPrazo({ content: item.prazo, error: false });
                const servicoEncontrado = novaListaServicos.find(
                  (servico) => servico.label === item.ServicosORM.descricao
                );
                const resultado = servicoEncontrado
                  ? {
                      value: servicoEncontrado.value,
                      label: servicoEncontrado.label,
                    }
                  : null;
                setServico({ content: resultado, error: false });
                handleOpenModalInsert();
              } catch (error) {
                console.log(error);
              }
            },
          },
          {
            icon: <DeleteForeverIcon />,
            title: "EXCLUIR",
            onClick: () => {
              setIdCondicaoComercial(item.idCondicaoComercial);
              handleOpenModalDelete();
            },
          },
        ],
      };
    });
  };

  let debounceTimeout;

  const handlePesquisaPorTexto = async (value) => {
    
    if (!value) {
      handleAtualizaDados();
    } else {
      clearTimeout(debounceTimeout);
      // debounceTimeout = setTimeout(async () => {
        try {
          const response = await buscarCondicoesComerciaisPorTexto(
            idGrupoEconomico,
            value
          );
          setData(handleOrganizaData(response.condicoesComerciais));
        } catch (error) {
          if (error.response.status == 404) {
            setData([]);
          } else {
            setMsg(error.response.data.mensagem);
            setOpenSnackErro(true);
          }
        }
      // }, 500);
    }
  };

  const handleSubmitInsert = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validoDe.content) validoDe.error = true;
    if (!servico.content) servico.error = true;

    if (validoDe.error || servico.error) {
      setMsg("Preencha todos os campos obrigatórios.");
      setOpenSnackErro(true);
      setLoading(false);
      return;
    }

    const validoDeFormatada = new Date(validoDe.content)
      .toISOString()
      .slice(0, 10);

    const objInsert = {
      condicaoComercial: {
        idGrupoEconomico,
        idServico: parseInt(servico.content.value),
        validoDe: validoDeFormatada,
        percentual: percentual.content || "0",
        imposto: imposto.content || "0",
        prazo: prazo.content || "0",
      },
      
    };

    try {
      console.log('objInsert ==========>>>>>>>>', objInsert);
      const response = await cadastrarCondicaoComercial(objInsert);
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!validoDe) setValidoDe({ content: null, error: true });

    if (!validoDe.content && typeof validoDe != "string") validoDe.error = true;

    if (!servico.content) servico.error = true;

    if (validoDe.error || servico.error) {
      setMsg("Preencha todos os campos obrigatórios.");
      setOpenSnackErro(true);
      setLoading(false);
      return;
    }

    // const validoDeFormatada = new Date(validoDe).toISOString().slice(0, 10);

    const objUpdate = {
      condicaoComercial: {
        idGrupoEconomico,
        idServico: parseInt(servico.content.value),
        validoDe: validoDe.content,
        percentual: percentual.content || "0",
        imposto: imposto.content || "0",
        prazo: prazo.content || "0",
      },
    };

    try {
      const response = await atualizarCondicaoComercial(
        objUpdate,
        idCondicaoComercial
      );
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const handleSubmitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await excluirCondicaoComercial(idCondicaoComercial);
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalDelete();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const pulse = keyframes`
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }`;

  const handleChangeValue = (name, value) => {
    switch (name) {
      case "validoDe":
        if (!isNaN(value.getTime())) {
          setValidoDe({
            content: value,
            error: value != null ? false : true,
          });
        } else {
          setValidoDe({
            content: value,
            error: true,
          });
        }
        break;
      case "percentual":
        setPercentual({ content: value, error: value != null ? false : true });
        break;
      case "imposto":
        setImposto({ content: value, error: value != null ? false : true });
        break;
      case "servico":
        setServico({ content: value, error: value != null ? false : true });
        break;
      case "prazo":
        setPrazo({ content: value, error: value != null ? false : true });
        break;
      default:
        break;
    }
  };

  const handleBuscaEmpresas = (obj) => {
    setIdGrupoEconomico(parseInt(obj.GE?.id));
  };

  return (
    <>

          <TableCard
            iconHeader={<HandshakeSharp fontSize="1rem" />}
            titleHeader="Condição Comercial"
            data={data}
            setData={setData}
            columns={columns}
            loading={loading}
            handleDebounce={handlePesquisaPorTexto}
            page={page}
            setPage={setPage}
            rowsPage={rowsPage}
            setRowsPage={setRowsPage}
            handleGrupoEmpresa={handleBuscaEmpresas}
          />
          {idGrupoEconomico ? (
            <Fab
              sx={{
                background: "#4b6fc0",
                bottom: 40,
                right: 20,
                position: "fixed",
                zIndex: 1000,
                animation: `${pulse} 1.5s infinite ease-in-out`,
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
              aria-label="add"
              onClick={() => {
                setIsEdit(false);
                handleOpenModalInsert();
              }}
            >
              <AddIcon className={styles.iconeAdd} />
            </Fab>
          ): ""}
      <Dialog fullWidth open={openModalInsert} onClose={handleCloseModalInsert}>
        <DialogTitle>
          <h4>{isEdit ? "Atualizar" : "Inserir"} condição comercial</h4>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={isEdit ? handleSubmitUpdate : handleSubmitInsert}>
            <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={12} sm={6}>
                <GenericDatePicker
                  key={"validoDe"}
                  label={`Válido de`}
                  value={validoDe}
                  name="inputValidoDe"
                  error={validoDe.error}
                  onChange={(value) => handleChangeValue("validoDe", value)}
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  error={percentual.error}
                  value={percentual.content}
                  onChange={(event) =>
                    handleChangeValue("percentual", event.target.value)
                  }
                  fullWidth
                  size="small"
                  label="Percentual"
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  error={imposto.error}
                  value={imposto.content}
                  onChange={(event) =>
                    handleChangeValue("imposto", event.target.value)
                  }
                  fullWidth
                  size="small"
                  label="Imposto"
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  sx={{ marginTop: "1rem" }}
                  size="small"
                  options={listaServicos}
                  value={servico.content}
                  onChange={(_, value) => handleChangeValue("servico", value)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      error={servico.error}
                      {...params}
                      label="Serviço"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  error={prazo.error}
                  value={prazo.content}
                  onChange={(event) =>
                    handleChangeValue("prazo", event.target.value)
                  }
                  fullWidth
                  size="small"
                  label="Prazo"
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
            </Grid>
            <DialogActions
              sx={{
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <WhiteButton
                clickFunction={handleCloseModalInsert}
                textValue="Fechar"
                contentIcon={<CloseIcon />}
                iconLeft
              />

              <BlueButton
                clickFunction={isEdit ? handleSubmitUpdate : handleSubmitInsert}
                textValue="Salvar"
                type="submit"
                contentIcon={<SendIcon />}
              />
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={openModalDelete} onClose={handleCloseModalDelete}>
        <DialogContent>
          <h2 style={{ fontSize: "1.1rem" }}>
            Deseja mesmo excluir essa condição comercial?
          </h2>
          <div className={styles.containerButtons}>
            <WhiteButton
              textValue="Não"
              contentIcon={<CloseIcon />}
              clickFunction={handleCloseModalDelete}
              iconLeft
            />
            <BlueButton
              textValue="Sim"
              contentIcon={<CheckIcon />}
              clickFunction={handleSubmitDelete}
            />
          </div>
        </DialogContent>
      </Dialog>

      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </>
  );
};

export default CondicaoComercial;
